import { FC } from 'react'
import { IconButton } from '@mui/material'
import { ICellRendererParams } from 'ag-grid-community'
import ModeEditOutlinedIcon from '@mui/icons-material/ModeEditOutlined'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'

interface DeviceMappingActionsProps {
  params: ICellRendererParams
  handleEditDevice: (data: any) => void
  handleDeleteDevice: (data: any) => void
}

const DeviceMappingActions: FC<DeviceMappingActionsProps> = ({
  params,
  handleEditDevice,
  handleDeleteDevice,
}) => {
  return (
    <>
      <IconButton
        size='small'
        id='edit-prorithm-device'
        onClick={() => handleEditDevice(params?.data)}
      >
        <ModeEditOutlinedIcon
          fontSize='small'
          id='edit-prorithm-device-mode-icon'
        />
      </IconButton>
      <IconButton
        size='small'
        id='delete-prorithm-device'
        disabled={!params?.data?.mappingId}
        onClick={() => handleDeleteDevice(params?.data)}
      >
        <DeleteOutlineIcon fontSize='small' id='delete-prorithm-device-icon' />
      </IconButton>
    </>
  )
}
export default DeviceMappingActions
